
export type Kamoku = {
  /**
   * 表示順
   */
  order: number;
  /**
   * 科目タイプ
   */
  type: string;

  kmkKbnCode: string;
  kmkKbnName: string;
  knjKmkCode: string;
  knjKmkName: string;
  hojoCode: string | null;
  hojoName: string | null;
}

export type ResponseSettingItem = {
  sources: Kamoku[];
  targets: Kamoku[];
}

export interface HasId {
  id: string;
}

export const outputFundTypeType = {
  Shushikin: 'Shushikin',
  Kikin: 'Kikin',
  All: 'All'
} as const

export type OutputFundTypeType = typeof outputFundTypeType[keyof typeof outputFundTypeType];

export const taishakuTaishoElementTypeType = {
  Shisan: 'Shisan',
  Fusai: 'Fusai',
  Junshisan: 'Junshisan',
  FusaiJunshisan: 'FusaiJunshisan'
} as const

export type TaishakuTaishoElementTypeType = typeof taishakuTaishoElementTypeType[keyof typeof taishakuTaishoElementTypeType];

export const taishakuTaishoCategoryTypeType = {
  RyudoShisan: 'RyudoShisan',
  KoteiShisan: 'KoteiShisan',
  RyudoFusai: 'RyudoFusai',
  KoteiFusai: 'KoteiFusai',
  TsumitateKin: 'TsumitateKin',
  HyokaSagaku: 'HyokaSagaku'
} as const

export type TaishakuTaishoCategoryTypeType = typeof taishakuTaishoCategoryTypeType[keyof typeof taishakuTaishoCategoryTypeType];

export const taishakuTaishoSubcategoryTypeType = {
  YukeiKoteiShisan: 'YukeiKoteiShisan',
  MukeiKoteiShisan: 'MukeiKoteiShisan',
  OtherShisan: 'OtherShisan'
} as const

export type TaishakuTaishoSubcategoryTypeType = typeof taishakuTaishoSubcategoryTypeType[keyof typeof taishakuTaishoSubcategoryTypeType];

export const taishakuTaishoKmkTypeType = {
  ShisanGokei: 'ShisanGokei',
  RyudoShisan: 'RyudoShisan',
  Genkin: 'Genkin',
  JigyoMishukin: 'JigyoMishukin',
  YukaShokenRyudo: 'YukaShokenRyudo',
  TanaoroshiShisan: 'TanaoroshiShisan',
  MaewatashiKin: 'MaewatashiKin',
  MaebaraiHiyou: 'MaebaraiHiyou',
  OtherRyudoShisan: 'OtherRyudoShisan',
  KoteiShisanGokei: 'KoteiShisanGokei',
  YukeiKoteiShisan: 'YukeiKoteiShisan',
  Tatemono: 'Tatemono',
  Kochikubutsu: 'Kochikubutsu',
  IryoKikai: 'IryoKikai',
  OtherKikai: 'OtherKikai',
  SharyoSenpaku: 'SharyoSenpaku',
  Tochi: 'Tochi',
  KensetsuKari: 'KensetsuKari',
  OtherYukeiKotei: 'OtherYukeiKotei',
  MukeiKoteiShisan: 'MukeiKoteiShisan',
  Shakuchiken: 'Shakuchiken',
  Software: 'Software',
  OtherMukeiKotei: 'OtherMukeiKotei',
  OtherShisan: 'OtherShisan',
  YukaShokenKotei: 'YukaShokenKotei',
  ChokiKashitsuke: 'ChokiKashitsuke',
  HoyuIryoKikanSai: 'HoyuIryoKikanSai',
  OtherChokiKashitsukeKin: 'OtherChokiKashitsukeKin',
  YakushokuChokiKashitsukeKin: 'YakushokuChokiKashitsukeKin',
  ChokiMaebarai: 'ChokiMaebarai',
  KurinobeZeikinShisan: 'KurinobeZeikinShisan',
  OtherKoteiShisan: 'OtherKoteiShisan',
  FusaiGokei: 'FusaiGokei',
  RyudoFusai: 'RyudoFusai',
  ShiharaiTegata: 'ShiharaiTegata',
  Kaikakekin: 'Kaikakekin',
  TankiKarireKin: 'TankiKarireKin',
  MibaraiKin: 'MibaraiKin',
  MibaraiHiyou: 'MibaraiHiyou',
  MibaraiZei: 'MibaraiZei',
  MibaraiShouhizei: 'MibaraiShouhizei',
  MaeukeKin: 'MaeukeKin',
  Azukarikin: 'Azukarikin',
  MaeukeShueki: 'MaeukeShueki',
  HikiateKinRyudo: 'HikiateKinRyudo',
  OtherRyudoFusai: 'OtherRyudoFusai',
  KoteiFusai: 'KoteiFusai',
  IryoKikanSai: 'IryoKikanSai',
  ChokiKarireKin: 'ChokiKarireKin',
  KurinobeZeikinFusai: 'KurinobeZeikinFusai',
  HikiateKinKotei: 'HikiateKinKotei',
  OtherKoteiFusai: 'OtherKoteiFusai',
  Shushikin: 'Shushikin',
  JunshisanGokei: 'JunshisanGokei',
  Kikin: 'Kikin',
  TsumitateKin: 'TsumitateKin',
  DaitaiKikin: 'DaitaiKikin',
  KurikoshiRiekiTsumitateKin: 'KurikoshiRiekiTsumitateKin',
  OtherTsumitateKin: 'OtherTsumitateKin',
  HyokaSagaku: 'HyokaSagaku',
  OtherYukaShokenSagaku: 'OtherYukaShokenSagaku',
  KurinobeHedge: 'KurinobeHedge',
  FusaiJunshisanGokei: 'FusaiJunshisanGokei'
} as const
export type TaishakuTaishoKmkTypeType = typeof taishakuTaishoKmkTypeType[keyof typeof taishakuTaishoKmkTypeType];

export const sonekiKeisanKmkTypeType = {
  HonraiJigyoShueki: 'HonraiJigyoShueki',
  HonraiJigyoHiyo: 'HonraiJigyoHiyo',
  HonraiJigyohi: 'HonraiJigyohi',
  HonraiHonbuhi: 'HonraiHonbuhi',
  HonraiRieki: 'HonraiRieki',
  FutaiJigyoShueki: 'FutaiJigyoShueki',
  FutaiJigyoHiyo: 'FutaiJigyoHiyo',
  FutaiRieki: 'FutaiRieki',
  ShuekiJigyoShueki: 'ShuekiJigyoShueki',
  ShuekiJigyoHiyo: 'ShuekiJigyoHiyo',
  ShuekiRieki: 'ShuekiRieki',
  JigyoRieki: 'JigyoRieki',
  JigyoGaiShueki: 'JigyoGaiShueki',
  UketoriRisoku: 'UketoriRisoku',
  OtherJigyoGaiShueki: 'OtherJigyoGaiShueki',
  JigyoGaiHiyo: 'JigyoGaiHiyo',
  ShiharaiRisoku: 'ShiharaiRisoku',
  OtherJigyoGaiHiyo: 'OtherJigyoGaiHiyo',
  KeijoRieki: 'KeijoRieki',
  TokubetsuRieki: 'TokubetsuRieki',
  KoteiShisanBaikyakuEki: 'KoteiShisanBaikyakuEki',
  OtherTokubetsuRieki: 'OtherTokubetsuRieki',
  TokubetsuSonshitsu: 'TokubetsuSonshitsu',
  KoteiShisanBaikyakuSon: 'KoteiShisanBaikyakuSon',
  OtherTokubetsuSonShitsu: 'OtherTokubetsuSonShitsu',
  ZeibikiMaeTokiJunRieki: 'ZeibikiMaeTokiJunRieki',
  HojinJuminJigyoZei: 'HojinJuminJigyoZei',
  HojinZeiChosei: 'HojinZeiChosei',
  TokiJunRieki: 'TokiJunRieki',
  Dummy: 'Dummy'
} as const
export type SonekiKeisanKmkTypeType = typeof sonekiKeisanKmkTypeType[keyof typeof sonekiKeisanKmkTypeType];

export const keieiJokyoKmkTypeType = {
  IgyoShueki: 'IgyoShueki',
  NyuinShueki: 'NyuinShueki',
  NyuinShuekiHoken: 'NyuinShuekiHoken',
  NyuinShuekiKogai: 'NyuinShuekiKogai',
  NyuinShuekiOther: 'NyuinShuekiOther',
  ShitsuryoShueki: 'ShitsuryoShueki',
  GairaiShueki: 'GairaiShueki',
  GairaiShuekiHoken: 'GairaiShuekiHoken',
  GairaiShuekiKogai: 'GairaiShuekiKogai',
  GairaiShuekiOther: 'GairaiShuekiOther',
  OtherShueki: 'OtherShueki',
  OtherShuekiHoken: 'OtherShuekiHoken',
  OtherShuekiUnei: 'OtherShuekiUnei',
  IgyoHiyo: 'IgyoHiyo',
  Zairyohi: 'Zairyohi',
  Iyakuhinhi: 'Iyakuhinhi',
  ShinryoZairyohi: 'ShinryoZairyohi',
  KyushokuZairyohi: 'KyushokuZairyohi',
  Kyuyohi: 'Kyuyohi',
  KyuyohiShohizei: 'KyuyohiShohizei',
  YakuinHoshu: 'YakuinHoshu',
  Kyuryo: 'Kyuryo',
  Shoyo: 'Shoyo',
  ShoyoHikiatekin: 'ShoyoHikiatekin',
  TaishokuKyuhuHiyo: 'TaishokuKyuhuHiyo',
  HoteiFukurihi: 'HoteiFukurihi',
  Itakuhi: 'Itakuhi',
  KyushokuItakuhi: 'KyushokuItakuhi',
  SetsubiKankeihi: 'SetsubiKankeihi',
  SetsubiKankeihiShohizei: 'SetsubiKankeihiShohizei',
  GenkaShokyakuhi: 'GenkaShokyakuhi',
  KikiChinshakuryo: 'KikiChinshakuryo',
  KenkyuKenshuhi: 'KenkyuKenshuhi',
  KenkyuKenshuhiShohizei: 'KenkyuKenshuhiShohizei',
  Keihi: 'Keihi',
  KeihiShohizei: 'KeihiShohizei',
  OtherIgyoHiyo: 'OtherIgyoHiyo',
  OtherIgyoHiyoShohizei: 'OtherIgyoHiyoShohizei',
  SuidoKonetsuhi: 'SuidoKonetsuhi',
  KojoShohizeiFutan: 'KojoShohizeiFutan',
  HonbuhiHaifu: 'HonbuhiHaifu',
  IgyoRieki: 'IgyoRieki',
  IgyogaiShueki: 'IgyogaiShueki',
  IgyogaiShuekiUketori: 'IgyogaiShuekiUketori',
  IgyogaiShuekiUnei: 'IgyogaiShuekiUnei',
  IgyogaiShuekiShisetsu: 'IgyogaiShuekiShisetsu',
  IgyogaiHiyo: 'IgyogaiHiyo',
  ShiharaiRisoku: 'ShiharaiRisoku',
  KeijoRieki: 'KeijoRieki',
  RinjiShueki: 'RinjiShueki',
  RinjiShuekiUnei: 'RinjiShuekiUnei',
  RinjiShuekiShisetsu: 'RinjiShuekiShisetsu',
  RinjiHiyo: 'RinjiHiyo',
  ZeibikimaeToukiJunrieki: 'ZeibikimaeToukiJunrieki',
  HojinJuminFutan: 'HojinJuminFutan',
  ToukiJunrieki: 'ToukiJunrieki',
  Dummy: 'Dummy'
} as const
export type KeieiJokyoKmkTypeType = typeof keieiJokyoKmkTypeType[keyof typeof keieiJokyoKmkTypeType];

export const optionalKeieiJokyoKmkTypeType = [
  keieiJokyoKmkTypeType.NyuinShuekiHoken,
  keieiJokyoKmkTypeType.NyuinShuekiKogai,
  keieiJokyoKmkTypeType.ShitsuryoShueki,
  keieiJokyoKmkTypeType.GairaiShuekiHoken,
  keieiJokyoKmkTypeType.GairaiShuekiKogai,
  keieiJokyoKmkTypeType.OtherShuekiHoken,
  keieiJokyoKmkTypeType.KyushokuItakuhi,
  keieiJokyoKmkTypeType.HonbuhiHaifu,
  keieiJokyoKmkTypeType.IgyogaiShuekiUketori,
  keieiJokyoKmkTypeType.ShiharaiRisoku,
  keieiJokyoKmkTypeType.RinjiShueki,
  keieiJokyoKmkTypeType.RinjiHiyo,
  keieiJokyoKmkTypeType.HojinJuminFutan
] as const
export type OptionalKeieiJokyoKmkTypeType = typeof optionalKeieiJokyoKmkTypeType[number]

export const hospitalClinicKbnType = {
  Hospital: 'Hospital',
  Clinic: 'Clinic'
} as const
export type HospitalClinicKbnType = typeof hospitalClinicKbnType[keyof typeof hospitalClinicKbnType];

export const shokushuTypeType = {
  Doctor: 'Doctor',
  Dentist: 'Dentist',
  Pharmacist: 'Pharmacist',
  NursingStaff: 'NursingStaff',
  PublicHealthNurse: 'PublicHealthNurse',
  Midwife: 'Midwife',
  Nurse: 'Nurse',
  AssistantNurse: 'AssistantNurse',
  OtherMedicalTechnicians: 'OtherMedicalTechnicians',
  RadiologicalTechnologist: 'RadiologicalTechnologist',
  ClinicalEngineer: 'ClinicalEngineer',
  MedicalLaboratoryTechnologist: 'MedicalLaboratoryTechnologist',
  RehabilitationStaff: 'RehabilitationStaff',
  PhysicalTherapist: 'PhysicalTherapist',
  OccupationalTherapist: 'OccupationalTherapist',
  Orthoptist: 'Orthoptist',
  SpeechTherapist: 'SpeechTherapist',
  DentalHygienist: 'DentalHygienist',
  DentalTechnician: 'DentalTechnician',
  NutritionistEtc: 'NutritionistEtc',
  Dietitian: 'Dietitian',
  Nutritionist: 'Nutritionist',
  Cook: 'Cook',
  SocialWorker: 'SocialWorker',
  PsychiatricSocialWorker: 'PsychiatricSocialWorker',
  NurseryTeacher: 'NurseryTeacher',
  NursingAssistant: 'NursingAssistant',
  OfficeStaff: 'OfficeStaff',
  AdministrativeStaff: 'AdministrativeStaff',
  MedicalClerk: 'MedicalClerk',
  MedicalInformationManager: 'MedicalInformationManager',
  OtherStaff: 'OtherStaff'
} as const
export type ShokushuTypeType = typeof shokushuTypeType[keyof typeof shokushuTypeType];

export const shokushuTypeLabels: Record<ShokushuTypeType, string> = {
  Doctor: '医師',
  Dentist: '歯科医師',
  Pharmacist: '薬剤師',
  NursingStaff: '看護職員',
  PublicHealthNurse: '保健師',
  Midwife: '助産師',
  Nurse: '看護師',
  AssistantNurse: '准看護師',
  OtherMedicalTechnicians: 'その他の医療技術者等',
  RadiologicalTechnologist: '診療放射線技師',
  ClinicalEngineer: '臨床工学技士',
  MedicalLaboratoryTechnologist: '臨床検査技師',
  RehabilitationStaff: 'リハビリスタッフ',
  PhysicalTherapist: '理学療法士',
  OccupationalTherapist: '作業療法士',
  Orthoptist: '視能訓練士',
  SpeechTherapist: '言語聴覚士',
  DentalHygienist: '歯科衛生士',
  DentalTechnician: '歯科技工士',
  NutritionistEtc: '栄養士等',
  Dietitian: '管理栄養士',
  Nutritionist: '栄養士',
  Cook: '調理師',
  SocialWorker: '社会福祉士',
  PsychiatricSocialWorker: '精神保健福祉士',
  NurseryTeacher: '保育士',
  NursingAssistant: '看護補助者',
  OfficeStaff: '事務職員',
  AdministrativeStaff: '事務担当職員',
  MedicalClerk: '医師事務作業補助者',
  MedicalInformationManager: '診療情報管理士',
  OtherStaff: 'その他の職員'
}

export const workTypeType = {
  Jokin: 'Jokin',
  Hijokin: 'Hijokin',
  KubunFuka: 'KubunFuka'
} as const
export type WorkTypeType = typeof workTypeType[keyof typeof workTypeType];

export const workTypeLabels: Record<WorkTypeType, string> = {
  Jokin: '常勤',
  Hijokin: '非常勤',
  KubunFuka: '常勤非常勤区分不可'
}

export const shokushuKmkTypeType = {
  DoctorJokinKyuryo: 'DoctorJokinKyuryo',
  DoctorJokinShouyo: 'DoctorJokinShouyo',
  DoctorJokinKubunFuka: 'DoctorJokinKubunFuka',
  DoctorJokinNinzu: 'DoctorJokinNinzu',
  DoctorHijokinKyuyo: 'DoctorHijokinKyuyo',
  DoctorHijokinNinzu: 'DoctorHijokinNinzu',
  DoctorKubunFukaKyuryo: 'DoctorKubunFukaKyuryo',
  DoctorKubunFukaShouyo: 'DoctorKubunFukaShouyo',
  DoctorKubunFukaKubunFuka: 'DoctorKubunFukaKubunFuka',
  DoctorKubunFukaNinzu: 'DoctorKubunFukaNinzu',
  DentistJokinKyuryo: 'DentistJokinKyuryo',
  DentistJokinShouyo: 'DentistJokinShouyo',
  DentistJokinKubunFuka: 'DentistJokinKubunFuka',
  DentistJokinNinzu: 'DentistJokinNinzu',
  DentistHijokinKyuyo: 'DentistHijokinKyuyo',
  DentistHijokinNinzu: 'DentistHijokinNinzu',
  DentistKubunFukaKyuryo: 'DentistKubunFukaKyuryo',
  DentistKubunFukaShouyo: 'DentistKubunFukaShouyo',
  DentistKubunFukaKubunFuka: 'DentistKubunFukaKubunFuka',
  DentistKubunFukaNinzu: 'DentistKubunFukaNinzu',
  PharmacistJokinKyuryo: 'PharmacistJokinKyuryo',
  PharmacistJokinShouyo: 'PharmacistJokinShouyo',
  PharmacistJokinKubunFuka: 'PharmacistJokinKubunFuka',
  PharmacistJokinNinzu: 'PharmacistJokinNinzu',
  PharmacistHijokinKyuyo: 'PharmacistHijokinKyuyo',
  PharmacistHijokinNinzu: 'PharmacistHijokinNinzu',
  PharmacistKubunFukaKyuryo: 'PharmacistKubunFukaKyuryo',
  PharmacistKubunFukaShouyo: 'PharmacistKubunFukaShouyo',
  PharmacistKubunFukaKubunFuka: 'PharmacistKubunFukaKubunFuka',
  PharmacistKubunFukaNinzu: 'PharmacistKubunFukaNinzu',
  NursingStaffJokinKyuryo: 'NursingStaffJokinKyuryo',
  NursingStaffJokinShouyo: 'NursingStaffJokinShouyo',
  NursingStaffJokinKubunFuka: 'NursingStaffJokinKubunFuka',
  NursingStaffJokinNinzu: 'NursingStaffJokinNinzu',
  NursingStaffHijokinKyuyo: 'NursingStaffHijokinKyuyo',
  NursingStaffHijokinNinzu: 'NursingStaffHijokinNinzu',
  NursingStaffKubunFukaKyuryo: 'NursingStaffKubunFukaKyuryo',
  NursingStaffKubunFukaShouyo: 'NursingStaffKubunFukaShouyo',
  NursingStaffKubunFukaKubunFuka: 'NursingStaffKubunFukaKubunFuka',
  NursingStaffKubunFukaNinzu: 'NursingStaffKubunFukaNinzu',
  PublicHealthNurseJokinKyuryo: 'PublicHealthNurseJokinKyuryo',
  PublicHealthNurseJokinShouyo: 'PublicHealthNurseJokinShouyo',
  PublicHealthNurseJokinKubunFuka: 'PublicHealthNurseJokinKubunFuka',
  PublicHealthNurseJokinNinzu: 'PublicHealthNurseJokinNinzu',
  PublicHealthNurseHijokinKyuyo: 'PublicHealthNurseHijokinKyuyo',
  PublicHealthNurseHijokinNinzu: 'PublicHealthNurseHijokinNinzu',
  PublicHealthNurseKubunFukaKyuryo: 'PublicHealthNurseKubunFukaKyuryo',
  PublicHealthNurseKubunFukaShouyo: 'PublicHealthNurseKubunFukaShouyo',
  PublicHealthNurseKubunFukaKubunFuka: 'PublicHealthNurseKubunFukaKubunFuka',
  PublicHealthNurseKubunFukaNinzu: 'PublicHealthNurseKubunFukaNinzu',
  MidwifeJokinKyuryo: 'MidwifeJokinKyuryo',
  MidwifeJokinShouyo: 'MidwifeJokinShouyo',
  MidwifeJokinKubunFuka: 'MidwifeJokinKubunFuka',
  MidwifeJokinNinzu: 'MidwifeJokinNinzu',
  MidwifeHijokinKyuyo: 'MidwifeHijokinKyuyo',
  MidwifeHijokinNinzu: 'MidwifeHijokinNinzu',
  MidwifeKubunFukaKyuryo: 'MidwifeKubunFukaKyuryo',
  MidwifeKubunFukaShouyo: 'MidwifeKubunFukaShouyo',
  MidwifeKubunFukaKubunFuka: 'MidwifeKubunFukaKubunFuka',
  MidwifeKubunFukaNinzu: 'MidwifeKubunFukaNinzu',
  NurseJokinKyuryo: 'NurseJokinKyuryo',
  NurseJokinShouyo: 'NurseJokinShouyo',
  NurseJokinKubunFuka: 'NurseJokinKubunFuka',
  NurseJokinNinzu: 'NurseJokinNinzu',
  NurseHijokinKyuyo: 'NurseHijokinKyuyo',
  NurseHijokinNinzu: 'NurseHijokinNinzu',
  NurseKubunFukaKyuryo: 'NurseKubunFukaKyuryo',
  NurseKubunFukaShouyo: 'NurseKubunFukaShouyo',
  NurseKubunFukaKubunFuka: 'NurseKubunFukaKubunFuka',
  NurseKubunFukaNinzu: 'NurseKubunFukaNinzu',
  AssistantNurseJokinKyuryo: 'AssistantNurseJokinKyuryo',
  AssistantNurseJokinShouyo: 'AssistantNurseJokinShouyo',
  AssistantNurseJokinKubunFuka: 'AssistantNurseJokinKubunFuka',
  AssistantNurseJokinNinzu: 'AssistantNurseJokinNinzu',
  AssistantNurseHijokinKyuyo: 'AssistantNurseHijokinKyuyo',
  AssistantNurseHijokinNinzu: 'AssistantNurseHijokinNinzu',
  AssistantNurseKubunFukaKyuryo: 'AssistantNurseKubunFukaKyuryo',
  AssistantNurseKubunFukaShouyo: 'AssistantNurseKubunFukaShouyo',
  AssistantNurseKubunFukaKubunFuka: 'AssistantNurseKubunFukaKubunFuka',
  AssistantNurseKubunFukaNinzu: 'AssistantNurseKubunFukaNinzu',
  OtherMedicalTechniciansJokinKyuryo: 'OtherMedicalTechniciansJokinKyuryo',
  OtherMedicalTechniciansJokinShouyo: 'OtherMedicalTechniciansJokinShouyo',
  OtherMedicalTechniciansJokinKubunFuka: 'OtherMedicalTechniciansJokinKubunFuka',
  OtherMedicalTechniciansJokinNinzu: 'OtherMedicalTechniciansJokinNinzu',
  OtherMedicalTechniciansHijokinKyuyo: 'OtherMedicalTechniciansHijokinKyuyo',
  OtherMedicalTechniciansHijokinNinzu: 'OtherMedicalTechniciansHijokinNinzu',
  OtherMedicalTechniciansKubunFukaKyuryo: 'OtherMedicalTechniciansKubunFukaKyuryo',
  OtherMedicalTechniciansKubunFukaShouyo: 'OtherMedicalTechniciansKubunFukaShouyo',
  OtherMedicalTechniciansKubunFukaKubunFuka: 'OtherMedicalTechniciansKubunFukaKubunFuka',
  OtherMedicalTechniciansKubunFukaNinzu: 'OtherMedicalTechniciansKubunFukaNinzu',
  RadiologicalTechnologistJokinKyuryo: 'RadiologicalTechnologistJokinKyuryo',
  RadiologicalTechnologistJokinShouyo: 'RadiologicalTechnologistJokinShouyo',
  RadiologicalTechnologistJokinKubunFuka: 'RadiologicalTechnologistJokinKubunFuka',
  RadiologicalTechnologistJokinNinzu: 'RadiologicalTechnologistJokinNinzu',
  RadiologicalTechnologistHijokinKyuyo: 'RadiologicalTechnologistHijokinKyuyo',
  RadiologicalTechnologistHijokinNinzu: 'RadiologicalTechnologistHijokinNinzu',
  RadiologicalTechnologistKubunFukaKyuryo: 'RadiologicalTechnologistKubunFukaKyuryo',
  RadiologicalTechnologistKubunFukaShouyo: 'RadiologicalTechnologistKubunFukaShouyo',
  RadiologicalTechnologistKubunFukaKubunFuka: 'RadiologicalTechnologistKubunFukaKubunFuka',
  RadiologicalTechnologistKubunFukaNinzu: 'RadiologicalTechnologistKubunFukaNinzu',
  ClinicalEngineerJokinKyuryo: 'ClinicalEngineerJokinKyuryo',
  ClinicalEngineerJokinShouyo: 'ClinicalEngineerJokinShouyo',
  ClinicalEngineerJokinKubunFuka: 'ClinicalEngineerJokinKubunFuka',
  ClinicalEngineerJokinNinzu: 'ClinicalEngineerJokinNinzu',
  ClinicalEngineerHijokinKyuyo: 'ClinicalEngineerHijokinKyuyo',
  ClinicalEngineerHijokinNinzu: 'ClinicalEngineerHijokinNinzu',
  ClinicalEngineerKubunFukaKyuryo: 'ClinicalEngineerKubunFukaKyuryo',
  ClinicalEngineerKubunFukaShouyo: 'ClinicalEngineerKubunFukaShouyo',
  ClinicalEngineerKubunFukaKubunFuka: 'ClinicalEngineerKubunFukaKubunFuka',
  ClinicalEngineerKubunFukaNinzu: 'ClinicalEngineerKubunFukaNinzu',
  MedicalLaboratoryTechnologistJokinKyuryo: 'MedicalLaboratoryTechnologistJokinKyuryo',
  MedicalLaboratoryTechnologistJokinShouyo: 'MedicalLaboratoryTechnologistJokinShouyo',
  MedicalLaboratoryTechnologistJokinKubunFuka: 'MedicalLaboratoryTechnologistJokinKubunFuka',
  MedicalLaboratoryTechnologistJokinNinzu: 'MedicalLaboratoryTechnologistJokinNinzu',
  MedicalLaboratoryTechnologistHijokinKyuyo: 'MedicalLaboratoryTechnologistHijokinKyuyo',
  MedicalLaboratoryTechnologistHijokinNinzu: 'MedicalLaboratoryTechnologistHijokinNinzu',
  MedicalLaboratoryTechnologistKubunFukaKyuryo: 'MedicalLaboratoryTechnologistKubunFukaKyuryo',
  MedicalLaboratoryTechnologistKubunFukaShouyo: 'MedicalLaboratoryTechnologistKubunFukaShouyo',
  MedicalLaboratoryTechnologistKubunFukaKubunFuka: 'MedicalLaboratoryTechnologistKubunFukaKubunFuka',
  MedicalLaboratoryTechnologistKubunFukaNinzu: 'MedicalLaboratoryTechnologistKubunFukaNinzu',
  RehabilitationStaffJokinKyuryo: 'RehabilitationStaffJokinKyuryo',
  RehabilitationStaffJokinShouyo: 'RehabilitationStaffJokinShouyo',
  RehabilitationStaffJokinKubunFuka: 'RehabilitationStaffJokinKubunFuka',
  RehabilitationStaffJokinNinzu: 'RehabilitationStaffJokinNinzu',
  RehabilitationStaffHijokinKyuyo: 'RehabilitationStaffHijokinKyuyo',
  RehabilitationStaffHijokinNinzu: 'RehabilitationStaffHijokinNinzu',
  RehabilitationStaffKubunFukaKyuryo: 'RehabilitationStaffKubunFukaKyuryo',
  RehabilitationStaffKubunFukaShouyo: 'RehabilitationStaffKubunFukaShouyo',
  RehabilitationStaffKubunFukaKubunFuka: 'RehabilitationStaffKubunFukaKubunFuka',
  RehabilitationStaffKubunFukaNinzu: 'RehabilitationStaffKubunFukaNinzu',
  PhysicalTherapistJokinKyuryo: 'PhysicalTherapistJokinKyuryo',
  PhysicalTherapistJokinShouyo: 'PhysicalTherapistJokinShouyo',
  PhysicalTherapistJokinKubunFuka: 'PhysicalTherapistJokinKubunFuka',
  PhysicalTherapistJokinNinzu: 'PhysicalTherapistJokinNinzu',
  PhysicalTherapistHijokinKyuyo: 'PhysicalTherapistHijokinKyuyo',
  PhysicalTherapistHijokinNinzu: 'PhysicalTherapistHijokinNinzu',
  PhysicalTherapistKubunFukaKyuryo: 'PhysicalTherapistKubunFukaKyuryo',
  PhysicalTherapistKubunFukaShouyo: 'PhysicalTherapistKubunFukaShouyo',
  PhysicalTherapistKubunFukaKubunFuka: 'PhysicalTherapistKubunFukaKubunFuka',
  PhysicalTherapistKubunFukaNinzu: 'PhysicalTherapistKubunFukaNinzu',
  OccupationalTherapistJokinKyuryo: 'OccupationalTherapistJokinKyuryo',
  OccupationalTherapistJokinShouyo: 'OccupationalTherapistJokinShouyo',
  OccupationalTherapistJokinKubunFuka: 'OccupationalTherapistJokinKubunFuka',
  OccupationalTherapistJokinNinzu: 'OccupationalTherapistJokinNinzu',
  OccupationalTherapistHijokinKyuyo: 'OccupationalTherapistHijokinKyuyo',
  OccupationalTherapistHijokinNinzu: 'OccupationalTherapistHijokinNinzu',
  OccupationalTherapistKubunFukaKyuryo: 'OccupationalTherapistKubunFukaKyuryo',
  OccupationalTherapistKubunFukaShouyo: 'OccupationalTherapistKubunFukaShouyo',
  OccupationalTherapistKubunFukaKubunFuka: 'OccupationalTherapistKubunFukaKubunFuka',
  OccupationalTherapistKubunFukaNinzu: 'OccupationalTherapistKubunFukaNinzu',
  OrthoptistJokinKyuryo: 'OrthoptistJokinKyuryo',
  OrthoptistJokinShouyo: 'OrthoptistJokinShouyo',
  OrthoptistJokinKubunFuka: 'OrthoptistJokinKubunFuka',
  OrthoptistJokinNinzu: 'OrthoptistJokinNinzu',
  OrthoptistHijokinKyuyo: 'OrthoptistHijokinKyuyo',
  OrthoptistHijokinNinzu: 'OrthoptistHijokinNinzu',
  OrthoptistKubunFukaKyuryo: 'OrthoptistKubunFukaKyuryo',
  OrthoptistKubunFukaShouyo: 'OrthoptistKubunFukaShouyo',
  OrthoptistKubunFukaKubunFuka: 'OrthoptistKubunFukaKubunFuka',
  OrthoptistKubunFukaNinzu: 'OrthoptistKubunFukaNinzu',
  SpeechTherapistJokinKyuryo: 'SpeechTherapistJokinKyuryo',
  SpeechTherapistJokinShouyo: 'SpeechTherapistJokinShouyo',
  SpeechTherapistJokinKubunFuka: 'SpeechTherapistJokinKubunFuka',
  SpeechTherapistJokinNinzu: 'SpeechTherapistJokinNinzu',
  SpeechTherapistHijokinKyuyo: 'SpeechTherapistHijokinKyuyo',
  SpeechTherapistHijokinNinzu: 'SpeechTherapistHijokinNinzu',
  SpeechTherapistKubunFukaKyuryo: 'SpeechTherapistKubunFukaKyuryo',
  SpeechTherapistKubunFukaShouyo: 'SpeechTherapistKubunFukaShouyo',
  SpeechTherapistKubunFukaKubunFuka: 'SpeechTherapistKubunFukaKubunFuka',
  SpeechTherapistKubunFukaNinzu: 'SpeechTherapistKubunFukaNinzu',
  DentalHygienistJokinKyuryo: 'DentalHygienistJokinKyuryo',
  DentalHygienistJokinShouyo: 'DentalHygienistJokinShouyo',
  DentalHygienistJokinKubunFuka: 'DentalHygienistJokinKubunFuka',
  DentalHygienistJokinNinzu: 'DentalHygienistJokinNinzu',
  DentalHygienistHijokinKyuyo: 'DentalHygienistHijokinKyuyo',
  DentalHygienistHijokinNinzu: 'DentalHygienistHijokinNinzu',
  DentalHygienistKubunFukaKyuryo: 'DentalHygienistKubunFukaKyuryo',
  DentalHygienistKubunFukaShouyo: 'DentalHygienistKubunFukaShouyo',
  DentalHygienistKubunFukaKubunFuka: 'DentalHygienistKubunFukaKubunFuka',
  DentalHygienistKubunFukaNinzu: 'DentalHygienistKubunFukaNinzu',
  DentalTechnicianJokinKyuryo: 'DentalTechnicianJokinKyuryo',
  DentalTechnicianJokinShouyo: 'DentalTechnicianJokinShouyo',
  DentalTechnicianJokinKubunFuka: 'DentalTechnicianJokinKubunFuka',
  DentalTechnicianJokinNinzu: 'DentalTechnicianJokinNinzu',
  DentalTechnicianHijokinKyuyo: 'DentalTechnicianHijokinKyuyo',
  DentalTechnicianHijokinNinzu: 'DentalTechnicianHijokinNinzu',
  DentalTechnicianKubunFukaKyuryo: 'DentalTechnicianKubunFukaKyuryo',
  DentalTechnicianKubunFukaShouyo: 'DentalTechnicianKubunFukaShouyo',
  DentalTechnicianKubunFukaKubunFuka: 'DentalTechnicianKubunFukaKubunFuka',
  DentalTechnicianKubunFukaNinzu: 'DentalTechnicianKubunFukaNinzu',
  NutritionistEtcJokinKyuryo: 'NutritionistEtcJokinKyuryo',
  NutritionistEtcJokinShouyo: 'NutritionistEtcJokinShouyo',
  NutritionistEtcJokinKubunFuka: 'NutritionistEtcJokinKubunFuka',
  NutritionistEtcJokinNinzu: 'NutritionistEtcJokinNinzu',
  NutritionistEtcHijokinKyuyo: 'NutritionistEtcHijokinKyuyo',
  NutritionistEtcHijokinNinzu: 'NutritionistEtcHijokinNinzu',
  NutritionistEtcKubunFukaKyuryo: 'NutritionistEtcKubunFukaKyuryo',
  NutritionistEtcKubunFukaShouyo: 'NutritionistEtcKubunFukaShouyo',
  NutritionistEtcKubunFukaKubunFuka: 'NutritionistEtcKubunFukaKubunFuka',
  NutritionistEtcKubunFukaNinzu: 'NutritionistEtcKubunFukaNinzu',
  DietitianJokinKyuryo: 'DietitianJokinKyuryo',
  DietitianJokinShouyo: 'DietitianJokinShouyo',
  DietitianJokinKubunFuka: 'DietitianJokinKubunFuka',
  DietitianJokinNinzu: 'DietitianJokinNinzu',
  DietitianHijokinKyuyo: 'DietitianHijokinKyuyo',
  DietitianHijokinNinzu: 'DietitianHijokinNinzu',
  DietitianKubunFukaKyuryo: 'DietitianKubunFukaKyuryo',
  DietitianKubunFukaShouyo: 'DietitianKubunFukaShouyo',
  DietitianKubunFukaKubunFuka: 'DietitianKubunFukaKubunFuka',
  DietitianKubunFukaNinzu: 'DietitianKubunFukaNinzu',
  NutritionistJokinKyuryo: 'NutritionistJokinKyuryo',
  NutritionistJokinShouyo: 'NutritionistJokinShouyo',
  NutritionistJokinKubunFuka: 'NutritionistJokinKubunFuka',
  NutritionistJokinNinzu: 'NutritionistJokinNinzu',
  NutritionistHijokinKyuyo: 'NutritionistHijokinKyuyo',
  NutritionistHijokinNinzu: 'NutritionistHijokinNinzu',
  NutritionistKubunFukaKyuryo: 'NutritionistKubunFukaKyuryo',
  NutritionistKubunFukaShouyo: 'NutritionistKubunFukaShouyo',
  NutritionistKubunFukaKubunFuka: 'NutritionistKubunFukaKubunFuka',
  NutritionistKubunFukaNinzu: 'NutritionistKubunFukaNinzu',
  CookJokinKyuryo: 'CookJokinKyuryo',
  CookJokinShouyo: 'CookJokinShouyo',
  CookJokinKubunFuka: 'CookJokinKubunFuka',
  CookJokinNinzu: 'CookJokinNinzu',
  CookHijokinKyuyo: 'CookHijokinKyuyo',
  CookHijokinNinzu: 'CookHijokinNinzu',
  CookKubunFukaKyuryo: 'CookKubunFukaKyuryo',
  CookKubunFukaShouyo: 'CookKubunFukaShouyo',
  CookKubunFukaKubunFuka: 'CookKubunFukaKubunFuka',
  CookKubunFukaNinzu: 'CookKubunFukaNinzu',
  SocialWorkerJokinKyuryo: 'SocialWorkerJokinKyuryo',
  SocialWorkerJokinShouyo: 'SocialWorkerJokinShouyo',
  SocialWorkerJokinKubunFuka: 'SocialWorkerJokinKubunFuka',
  SocialWorkerJokinNinzu: 'SocialWorkerJokinNinzu',
  SocialWorkerHijokinKyuyo: 'SocialWorkerHijokinKyuyo',
  SocialWorkerHijokinNinzu: 'SocialWorkerHijokinNinzu',
  SocialWorkerKubunFukaKyuryo: 'SocialWorkerKubunFukaKyuryo',
  SocialWorkerKubunFukaShouyo: 'SocialWorkerKubunFukaShouyo',
  SocialWorkerKubunFukaKubunFuka: 'SocialWorkerKubunFukaKubunFuka',
  SocialWorkerKubunFukaNinzu: 'SocialWorkerKubunFukaNinzu',
  PsychiatricSocialWorkerJokinKyuryo: 'PsychiatricSocialWorkerJokinKyuryo',
  PsychiatricSocialWorkerJokinShouyo: 'PsychiatricSocialWorkerJokinShouyo',
  PsychiatricSocialWorkerJokinKubunFuka: 'PsychiatricSocialWorkerJokinKubunFuka',
  PsychiatricSocialWorkerJokinNinzu: 'PsychiatricSocialWorkerJokinNinzu',
  PsychiatricSocialWorkerHijokinKyuyo: 'PsychiatricSocialWorkerHijokinKyuyo',
  PsychiatricSocialWorkerHijokinNinzu: 'PsychiatricSocialWorkerHijokinNinzu',
  PsychiatricSocialWorkerKubunFukaKyuryo: 'PsychiatricSocialWorkerKubunFukaKyuryo',
  PsychiatricSocialWorkerKubunFukaShouyo: 'PsychiatricSocialWorkerKubunFukaShouyo',
  PsychiatricSocialWorkerKubunFukaKubunFuka: 'PsychiatricSocialWorkerKubunFukaKubunFuka',
  PsychiatricSocialWorkerKubunFukaNinzu: 'PsychiatricSocialWorkerKubunFukaNinzu',
  NurseryTeacherJokinKyuryo: 'NurseryTeacherJokinKyuryo',
  NurseryTeacherJokinShouyo: 'NurseryTeacherJokinShouyo',
  NurseryTeacherJokinKubunFuka: 'NurseryTeacherJokinKubunFuka',
  NurseryTeacherJokinNinzu: 'NurseryTeacherJokinNinzu',
  NurseryTeacherHijokinKyuyo: 'NurseryTeacherHijokinKyuyo',
  NurseryTeacherHijokinNinzu: 'NurseryTeacherHijokinNinzu',
  NurseryTeacherKubunFukaKyuryo: 'NurseryTeacherKubunFukaKyuryo',
  NurseryTeacherKubunFukaShouyo: 'NurseryTeacherKubunFukaShouyo',
  NurseryTeacherKubunFukaKubunFuka: 'NurseryTeacherKubunFukaKubunFuka',
  NurseryTeacherKubunFukaNinzu: 'NurseryTeacherKubunFukaNinzu',
  NursingAssistantJokinKyuryo: 'NursingAssistantJokinKyuryo',
  NursingAssistantJokinShouyo: 'NursingAssistantJokinShouyo',
  NursingAssistantJokinKubunFuka: 'NursingAssistantJokinKubunFuka',
  NursingAssistantJokinNinzu: 'NursingAssistantJokinNinzu',
  NursingAssistantHijokinKyuyo: 'NursingAssistantHijokinKyuyo',
  NursingAssistantHijokinNinzu: 'NursingAssistantHijokinNinzu',
  NursingAssistantKubunFukaKyuryo: 'NursingAssistantKubunFukaKyuryo',
  NursingAssistantKubunFukaShouyo: 'NursingAssistantKubunFukaShouyo',
  NursingAssistantKubunFukaKubunFuka: 'NursingAssistantKubunFukaKubunFuka',
  NursingAssistantKubunFukaNinzu: 'NursingAssistantKubunFukaNinzu',
  OfficeStaffJokinKyuryo: 'OfficeStaffJokinKyuryo',
  OfficeStaffJokinShouyo: 'OfficeStaffJokinShouyo',
  OfficeStaffJokinKubunFuka: 'OfficeStaffJokinKubunFuka',
  OfficeStaffJokinNinzu: 'OfficeStaffJokinNinzu',
  OfficeStaffHijokinKyuyo: 'OfficeStaffHijokinKyuyo',
  OfficeStaffHijokinNinzu: 'OfficeStaffHijokinNinzu',
  OfficeStaffKubunFukaKyuryo: 'OfficeStaffKubunFukaKyuryo',
  OfficeStaffKubunFukaShouyo: 'OfficeStaffKubunFukaShouyo',
  OfficeStaffKubunFukaKubunFuka: 'OfficeStaffKubunFukaKubunFuka',
  OfficeStaffKubunFukaNinzu: 'OfficeStaffKubunFukaNinzu',
  AdministrativeStaffJokinKyuryo: 'AdministrativeStaffJokinKyuryo',
  AdministrativeStaffJokinShouyo: 'AdministrativeStaffJokinShouyo',
  AdministrativeStaffJokinKubunFuka: 'AdministrativeStaffJokinKubunFuka',
  AdministrativeStaffJokinNinzu: 'AdministrativeStaffJokinNinzu',
  AdministrativeStaffHijokinKyuyo: 'AdministrativeStaffHijokinKyuyo',
  AdministrativeStaffHijokinNinzu: 'AdministrativeStaffHijokinNinzu',
  AdministrativeStaffKubunFukaKyuryo: 'AdministrativeStaffKubunFukaKyuryo',
  AdministrativeStaffKubunFukaShouyo: 'AdministrativeStaffKubunFukaShouyo',
  AdministrativeStaffKubunFukaKubunFuka: 'AdministrativeStaffKubunFukaKubunFuka',
  AdministrativeStaffKubunFukaNinzu: 'AdministrativeStaffKubunFukaNinzu',
  MedicalClerkJokinKyuryo: 'MedicalClerkJokinKyuryo',
  MedicalClerkJokinShouyo: 'MedicalClerkJokinShouyo',
  MedicalClerkJokinKubunFuka: 'MedicalClerkJokinKubunFuka',
  MedicalClerkJokinNinzu: 'MedicalClerkJokinNinzu',
  MedicalClerkHijokinKyuyo: 'MedicalClerkHijokinKyuyo',
  MedicalClerkHijokinNinzu: 'MedicalClerkHijokinNinzu',
  MedicalClerkKubunFukaKyuryo: 'MedicalClerkKubunFukaKyuryo',
  MedicalClerkKubunFukaShouyo: 'MedicalClerkKubunFukaShouyo',
  MedicalClerkKubunFukaKubunFuka: 'MedicalClerkKubunFukaKubunFuka',
  MedicalClerkKubunFukaNinzu: 'MedicalClerkKubunFukaNinzu',
  MedicalInformationManagerJokinKyuryo: 'MedicalInformationManagerJokinKyuryo',
  MedicalInformationManagerJokinShouyo: 'MedicalInformationManagerJokinShouyo',
  MedicalInformationManagerJokinKubunFuka: 'MedicalInformationManagerJokinKubunFuka',
  MedicalInformationManagerJokinNinzu: 'MedicalInformationManagerJokinNinzu',
  MedicalInformationManagerHijokinKyuyo: 'MedicalInformationManagerHijokinKyuyo',
  MedicalInformationManagerHijokinNinzu: 'MedicalInformationManagerHijokinNinzu',
  MedicalInformationManagerKubunFukaKyuryo: 'MedicalInformationManagerKubunFukaKyuryo',
  MedicalInformationManagerKubunFukaShouyo: 'MedicalInformationManagerKubunFukaShouyo',
  MedicalInformationManagerKubunFukaKubunFuka: 'MedicalInformationManagerKubunFukaKubunFuka',
  MedicalInformationManagerKubunFukaNinzu: 'MedicalInformationManagerKubunFukaNinzu',
  OtherStaffJokinKyuryo: 'OtherStaffJokinKyuryo',
  OtherStaffJokinShouyo: 'OtherStaffJokinShouyo',
  OtherStaffJokinKubunFuka: 'OtherStaffJokinKubunFuka',
  OtherStaffJokinNinzu: 'OtherStaffJokinNinzu',
  OtherStaffHijokinKyuyo: 'OtherStaffHijokinKyuyo',
  OtherStaffHijokinNinzu: 'OtherStaffHijokinNinzu',
  OtherStaffKubunFukaKyuryo: 'OtherStaffKubunFukaKyuryo',
  OtherStaffKubunFukaShouyo: 'OtherStaffKubunFukaShouyo',
  OtherStaffKubunFukaKubunFuka: 'OtherStaffKubunFukaKubunFuka',
  OtherStaffKubunFukaNinzu: 'OtherStaffKubunFukaNinzu',
  Dummy: 'Dummy'
} as const
export type ShokushuKmkTypeType = typeof shokushuKmkTypeType[keyof typeof shokushuKmkTypeType];
